import { ActivityEntityName, ContactType } from "@jms/model";

export enum CrmRouteName {

    ROOT = 'crm',

    Users = 'users',
    Contacts = 'contacts',
    Employee = 'employees',
    Teams = 'teams',
    Contractor = 'contractors',
    Supplier = 'suppliers',
    Customer = 'customers',
    Company = 'companies',
    Sites = 'sites',
    ServicePlans = 'service-plans',
    UpcomingWork = 'upcoming-work',
    Compliance = 'compliance',
    ServicePlanTemplates = 'service-plan-templates',
    Visits = 'visits',
    AccountSites = 'account-sites',
    ManageSites = 'managed-sites',
    Invites = 'invites',
    Companies = 'companies'
}

export enum CrmDialog {
    None = 'None',
    Site = 'Site',
    AddBasic = 'Add Basic',
    AddLogin = 'Add Login',
    EditChildContact = 'Edit Child Contact',
    InviteSuccess = 'Invite Success',
    ConnectSuccess = 'Connect Success',
    AddContact = 'Add Contact',
    MergeAccounts = 'Merge Accounts',
    ChangePassword = 'Change Password'
}

/**
 * Get the CRM route for a given contact type
 * @param type The contact type or activity entity name or string
 * @param includeRoot Whether to include the root path
 * @returns The CRM route
 */
export function getCrmRoute(type: ContactType | ActivityEntityName | string, includeRoot = true): string {
    let route = '';

    const map: Record<string, string> = {
        [ContactType.Subcontractor]: CrmRouteName.Contractor,
        [ContactType.Supplier]: CrmRouteName.Supplier,
        ['Company/Business Unit']: CrmRouteName.Company,
        [ContactType.WorkBuddyCompany]: CrmRouteName.Company,
        [ContactType.ServiceProvider]: CrmRouteName.Customer,
        [ContactType.Business]: CrmRouteName.Customer,
        [ContactType.Individual]: CrmRouteName.Customer,
        [ContactType.LoginContact]: CrmRouteName.Users,
        [ContactType.BasicContact]: CrmRouteName.Contacts,
        [ContactType.Team]: CrmRouteName.Teams,
        [ActivityEntityName.Site]: CrmRouteName.Sites,
        [ActivityEntityName.AccountSite]: CrmRouteName.AccountSites,
        [ActivityEntityName.ManagedSite]: CrmRouteName.ManageSites,
    }

    route = map[type];

    if (!route) {
        route = CrmRouteName.ROOT;
    }

    if (includeRoot) {
        return `/${CrmRouteName.ROOT}/${route}`;
    }

    return route;
}
